import { TopInsightsDesktop } from '@/organisms/00-ui/TopInsightsDesktop';
import { TopInsightsMobile } from '@/organisms/00-ui/TopInsightsMobile';
import { ITopInsightsSectionProps } from '@/organisms/01-sections/TopInsightsSection/index.types';

export const TopInsightsSection = ({ insights }: ITopInsightsSectionProps) => {
  return (
    <>
      <div className="h-[198px] w-full hidden lg:block">
        <TopInsightsDesktop insights={insights} />
      </div>

      <div className="w-full lg:hidden">
        <TopInsightsMobile insights={insights} />
      </div>
    </>
  );
};
